import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { FormlyModule } from '@ngx-formly/core';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';

import { TranslationModule } from '@lib/translation';
import { SnDateTimePickerFormField } from './components/form-field/date-time-picker.form-field';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    NgxMaterialTimepickerModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatMomentModule,
    NgxMatTimepickerModule,
    MatDatepickerModule,
    TranslationModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'datetimepicker',
          component: SnDateTimePickerFormField,
          wrappers: ['form-field'],
          defaultOptions: {
            templateOptions: {
              color: 'accent',
            },
          },
        },
      ],
    }),
  ],
  exports: [
    NgxMaterialTimepickerModule,
    SnDateTimePickerFormField,
    NgxMatNativeDateModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule,
    MatDatepickerModule,
  ],
  declarations: [SnDateTimePickerFormField],
})
export class FormDateTimepickerModule {}
